import React, { useState } from "react"
import { CheckboxSetting, Section } from "./Shared"
import { useSelector } from "react-redux"
import { useFormContext } from "react-hook-form"
import L10n from "../../../lib/carrot-l10n"
import { getEmailOptIn } from "../../../reducers/userInfo"
import { FormCheckbox } from "../atoms/Checkbox"
import { TextLink, Stack, Container } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const CommunicationSettings = () => {
  const { errors, register } = useFormContext()
  const currentEmailOptIn = useSelector(getEmailOptIn)
  const [emailOptIn, setEmailOptIn] = useState(currentEmailOptIn)

  const emailOptInSetting = (
    <FormCheckbox
      name={"emailOptIn"}
      label={l`client.accountSettings.emailOptIn`}
      checked={emailOptIn}
      onChange={(e) => setEmailOptIn(e.target.checked)}
      errors={errors}
      ref={register}
    />
  )

  return (
    <Section title="Communication settings" description="">
      <Container stack="small">
        <label>
          <CheckboxSetting
            title="Stay updated"
            description="Receive updates about your benefit, such as new features and partnerships, as well as member-only
          expert resources."
          >
            {emailOptInSetting}
          </CheckboxSetting>
        </label>
      </Container>
      <Stack direction="row" spacing="medium">
        <TextLink target="_blank" href="https://www.get-carrot.com/terms">
          Terms & Conditions
        </TextLink>
        <TextLink target="_blank" href="https://www.get-carrot.com/privacy-policy">
          Privacy Policy
        </TextLink>
      </Stack>
    </Section>
  )
}

export { CommunicationSettings }
